import ComponentScrollbar from './ComponentScrollbar';

export default ComponentScrollbar;
